export default __webpack_public_path__ + "static/media/tour-bretagne.14a8b006.jpg";